import { PriceSnapshot } from '../price';

export class ContractCityCacheCalendar {
  contractId: number;
  contractName: string;
  contractReference: string;
  originId: number;
  contractCacheCalendar: { [date: string]: PriceSnapshot };
}
